const API_URL = process.env.REACT_APP_API_URL || "https://vetcastle.com";
const API_V1 = `${API_URL}/api/v1`;
const LEGACY_API = `${API_URL}/api`;

export const API_ROUTES = {
  BASE_URL: API_URL,
  API_V1,
  BASE: `${API_V1}/hospitals`,
  ENTITIES: {
    PETS: `${API_V1}/pets`,
    PET_COUNT: `${API_V1}/pets/count`,
    PET_BY_ID: (id) => `${API_V1}/pets/${id}`,
    PET_OWNERS: `${API_V1}/pet-owners`,
    PET_OWNER_COUNT: `${API_V1}/pet-owners/count`,
    PET_OWNER_BY_ID: (id) => `${API_V1}/pet-owners/${id}`,
    PET_OWNER_ENABLE: (id) => `${API_V1}/pet-owners/${id}/enable`,
    PET_OWNER_DISABLE: (id) => `${API_V1}/pet-owners/${id}/disable`,
    CURRENT_PET_OWNER: (profileId) => `${API_V1}/pet-owners?profile_id=${profileId}&pageSize=1`,
  },
  BILLING: {
    INVOICES: `${API_V1}/billing/invoices`,
    COUNT: `${API_V1}/billing/invoices/count`,
    BY_ID: (id) => `${API_V1}/billing/invoices/${id}`,
    PAY: (id) => `${API_V1}/billing/invoices/${id}/pay`,
  },
  CLINICAL: {
    VISITS: `${API_V1}/clinical/visits`,
    VISIT_BY_ID: (id) => `${API_V1}/clinical/visits/${id}`,
    VISITS_BY_DOCTOR: (doctorId) => `${API_V1}/clinical/visits?doctor_id=${doctorId}`,
    SOAP_NOTE_FOR_VISIT: (visitId) => `${API_V1}/clinical/visits/${visitId}/soap-note`,
    FINALIZE_SOAP_NOTE: (soapNoteId) => `${API_V1}/clinical/soap-notes/${soapNoteId}/finalize`,
    VISIT_PRESCRIPTIONS: (visitId) => `${API_V1}/clinical/visits/${visitId}/prescriptions`,
    VISIT_LAB_REQUESTS: (visitId) => `${API_V1}/clinical/visits/${visitId}/lab-requests`,
    VISIT_DIAGNOSES: (visitId) => `${API_V1}/clinical/visits/${visitId}/diagnoses`,
  },

  AUTH: {
    SIGN_UP: `${API_V1}/auth/signup`,
    LOGIN: `${API_V1}/auth/login`,
    REFRESH: `${API_V1}/auth/refresh`,
    LOGOUT: `${API_V1}/auth/logout`,
  },

  RESOURCES: {
    BASE: `${API_V1}/resources`,
    HOSPITAL_SETTINGS: `${API_V1}/resources/hospital-settings`,
    HOSPITAL_CATEGORIES: `${API_V1}/resources/hospital-categories`,
    GENDER_TYPES: `${API_V1}/resources/gender-types`,
    FOOD_TYPES: `${API_V1}/resources/food-types`,
    PET_TYPES: `${API_V1}/resources/pet-types`,
  },

  ADMIN: {
    HOSPITALS: `${API_V1}/hospitals`,
    DASHBOARD_STATS: `${API_V1}/dashboard-stats`,
    HOSPITAL_STATS: (hospitalId) => `${API_V1}/hospitals/${hospitalId}/stats`,
  },

  NOTIFICATIONS: {
    BASE: `${API_V1}/notifications`,
    BY_USER: () => `${API_V1}/notifications`,
    MARK_READ: (id) => `${API_V1}/notifications/${id}/read`,
  },

  HOSPITAL: {
    BASE: `${API_V1}/hospitals`,
    SELF: `${API_V1}/hospitals/me`,
    SELF_PASSWORD: `${API_V1}/hospitals/me/password`,
    SETTINGS: `${API_V1}/profiles/settings`,

    INVENTORY: `${API_V1}/inventory`,
    INVENTORY_BATCHES: `${API_V1}/inventoryBatches`,
    INVENTORY_MOVEMENTS: `${API_V1}/inventory/movements`,
    INVENTORY_COUNT: `${API_V1}/inventory/count`,
    INVENTORY_LOW_STOCK_COUNT: `${API_V1}/inventory/count?low_stock=true`,
    STOCK_BATCH: `${API_V1}/inventoryBatches`,

    APPOINTMENTS: `${API_V1}/appointments`,
    APPOINTMENTS_COUNT: `${API_V1}/appointments/count`,

    DOCTOR: `${API_V1}/doctors`,
    DOCTORS: `${API_V1}/doctors`,
    DOCTOR_STATUS: (doctorId) => `${API_V1}/doctors/${doctorId}/status`,
    DOCTOR_COUNT: `${API_V1}/doctors/count`,
    DOCTOR_BRANCHES: `${API_V1}/doctor-branches`,
    dOCTOR_BRANCHES: `${API_V1}/doctor-branches`,

    STAFF: `${API_V1}/profiles/Staff`,
    STAFF_USERS: `${API_V1}/staff-users`,
    DEPARTMENTS: `${API_V1}/departments`,

    PET_OWNER: `${API_V1}/petOwnerManagement`,
    PET_OWNERS: `${API_V1}/petOwnerManagement`,
    PET_OWNER_ENABLE: `${API_V1}/petOwnerManagement/enable/`,
    PET_OWNER_DISABLE: `${API_V1}/petOwnerManagement/disable/`,
    PET_OWNER_COUNT: `${API_V1}/petOwnerManagement/count`,
    PETS: `${API_V1}/petManagement`,
    PET_COUNT: `${API_V1}/petManagement/count`,
    PET_TYPES: `${API_V1}/pet-types`,
    PET_TYPE_MAPPING: `${API_V1}/petTypeMapping`,
    PET_INSURANCES: `${API_V1}/pet-insurances`,
    FOOD_TYPES: `${API_V1}/food-types`,
    GENDER: `${API_V1}/gender-types`,

    CLINICAL_NOTES: `${API_V1}/clinical-notes`,
    SURGERIES: `${API_V1}/surgeries`,
    ADMISSIONS: `${API_V1}/admissions`,
    VISITS: `${API_V1}/visits`,
    PRESCRIPTIONS: `${API_V1}/prescriptions`,
    VACCINATIONS: `${API_V1}/vaccinations`,
    VACCINE_TYPES: `${API_V1}/vaccine-types`,
    LAB: `${API_V1}/lab/requests`,
    LAB_TESTS: `${API_V1}/lab/requests`,
    LAB_RESULTS: `${API_V1}/lab/results/`,
    LAB_REQUESTS: `${API_V1}/lab/requests`,

    PRODUCTS: `${API_V1}/products`,
    PHARMACY_PRODUCTS: `${API_V1}/products`,
    PRODUCTCATEGORY: `${API_V1}/product_categories`,
    PRODUCT_CATEGORIES: `${API_V1}/product_categories`,
    SUPPLIERS: `${API_V1}/suppliers`,
    PURCHASE_ORDERS: `${API_V1}/purchase-orders`,

    TRANSACTIONS: `${API_V1}/transactions`,

    BRANCHES: `${API_V1}/branches`,
    WARDS: `${API_V1}/wards`,
    CAGES: `${API_V1}/cages`,
    WAITLIST: `${API_V1}/waitlist`,

    REPORTS: `${API_V1}/reports`,
    REPORTS_API: `${API_V1}/reports`,
    DOCUMENTS: `${API_V1}/documents`,
    UPLOAD: `${API_URL}/upload`,
    ERROR_COUNTS: `${API_V1}/hospitals/errors/count`,
    CRITICAL_ERRORS: `${API_V1}/hospitals/errors/critical`,
    WARNING_ERRORS: `${API_V1}/hospitals/errors/warnings`,

    HOSPITAL_SUBSCRIPTIONS: `${API_V1}/hospital-subscriptions`,

    ADMIN: {
      BY_HOSPITAL: (hospitalId) => `${API_V1}/appointments/hospital/${hospitalId}`,
    },
  },

  DOCTOR: {
    APPOINTMENTS: `${API_V1}/appointments`,
    APPOINTMENTS_BY_DOCTOR: (doctorId) => `${API_V1}/appointments/doctor/${doctorId}`,
    PET_RECORDS: `${API_V1}/pets`,
    LAB_REQUESTS: `${API_V1}/lab/requests`,
    LAB_REQUESTS_BY_DOCTOR: (doctorId) => `${API_V1}/lab/requests/doctor/${doctorId}`,
    INVOICES: `${API_V1}/billing/invoices`,
    PRESCRIPTIONS: `${API_V1}/prescriptions`,
    PRESCRIPTIONS_BY_DOCTOR: (doctorId) => `${API_V1}/prescriptions/doctor/${doctorId}`,
    PRESCRIPTION_STATUS: (id) => `${API_V1}/prescriptions/${id}/status`,
  },

  PET_OWNER: {
    BASE: `${API_V1}/pet-owners`,
    BY_ID: (id) => `${API_V1}/pet-owners/${id}`,
    CURRENT: (profileId) => `${API_V1}/pet-owners?profile_id=${profileId}&pageSize=1`,
    PETS: `${API_V1}/pets`,
    APPOINTMENTS: `${API_V1}/appointments`,
    REQUEST_APPOINTMENT: `${API_V1}/appointments/requests`,
    CANCEL_APPOINTMENT: `${API_V1}/appointments`,
    VACCINATIONS: `${API_V1}/vaccinations/owner`,
  },

  DOCTOR_BRANCH: {
    BASE: `${API_V1}/doctor-branches`,
    UPDATE: (id) => `${API_V1}/doctor-branches/${id}`,
    DELETE: (id) => `${API_V1}/doctor-branches/${id}`,
  },

  LEGACY: {
    BASE: LEGACY_API,
  },

  PUBLIC: {
    CONTACT: `${API_V1}/contact`,
    CHATBOT_ASK: `${API_V1}/chatbot/ask`,
    CHATBOT_APPOINTMENT: `${API_V1}/chatbot/appointment`,
    REFERENCE: {
      HOSPITAL_CATEGORIES: `${API_V1}/public/reference/hospital-categories`,
      SUBSCRIPTION_PLANS: `${API_V1}/public/reference/subscription-plans`,
    },
  },

  REPORTS: {
    BASE: `${API_V1}/reports`,
    BY_ID: (id) => `${API_V1}/reports/${id}`,
  },

  PET_OWNER_SHORTCUTS: {
    MEDICINE_HISTORY: (ownerId) => `${API_V1}/pet-owners/${ownerId}/medicine-history`,
    LAB_RESULTS: (ownerId) => `${API_V1}/pet-owners/${ownerId}/lab-results`,
    PRESCRIPTIONS: (ownerId) => `${API_V1}/pet-owners/${ownerId}/prescriptions`,
    INVOICES: (ownerId) => `${API_V1}/pet-owners/${ownerId}/invoices`,
  },
};

export default API_ROUTES;

export const handleLogout = () => {
  localStorage.removeItem("accessToken");
};
